import i18n from '@/common/i18n';
import Layout from '@/layout/index';
import Detail from '@/views/LiveModule/detail';
import CustomerTab from '@/views/LiveModule/CustomerTabView';
const router = [
  {
    path: '/videoTailoring/:str(\\d+)',
    meta: {
      auth: true,
      title: '',
      name: 'videoTailoring'
    },
    component: () => import('@/views/LiveModule/PlayBack/videoTailoring'),
    hidden: true
  },
  {
    path: '/clientLiveEdit',
    meta: {
      auth: false,
      title: '',
      name: 'clientLiveEdit'
    },
    component: () => import('@/views/LiveModule/edit'),
    hidden: true
  },
  {
    path: '/previewChapter/:str(\\d+)',
    component: () => import('@/views/LiveModule/PlayBack/previewChapter'),
    meta: {
      auth: true,
      title: `${i18n.t('lang.k_016001')}`,
      name: 'previewChapter',
      activeMenu: '/live/list'
    },
    hidden: true
  },
  {
    path: '/chapter/:str(\\d+)',
    component: () => import('@/views/LiveModule/PlayBack/chapter'),
    meta: {
      auth: true,
      title: `${i18n.t('lang.k_016002')}`,
      name: 'chapter',
      activeMenu: '/live/list'
    },
    hidden: true
  },
  {
    path: '/recordchapter/:str(\\d+)',
    component: () => import('@/views/LiveModule/PlayBack/chapter'),
    meta: {
      auth: true,
      title: `${i18n.t('lang.k_016002')}`,
      name: 'recordchapter',
      activeMenu: '/live/list'
    },
    hidden: true
  },
  // 直播活动路由
  {
    path: '/live',
    component: Layout,
    redirect: '/live/list',
    meta: {
      auth: true,
      title: `${i18n.t('lang.k_016003')}`,
      icon: 'saasicon_lives_img',
      level: 1,
      name: 'liveMgr'
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/LiveModule/list'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016004')}`,
          level: 2,
          name: 'liveList'
        }
      },
      {
        path: 'edit',
        component: () => import('@/views/LiveModule/edit'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016005')}`,
          level: 2,
          name: 'liveCreate',
          webinarType: 'live',
          activeMenu: '/live/edit'
        }
      },
      {
        path: 'edit/:id',
        component: () => import('@/views/LiveModule/edit'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016006')}`,
          level: 2,
          name: 'liveEdit',
          webinarType: 'live',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'vodEdit/:id',
        component: () => import('@/views/LiveModule/edit'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016007')}`,
          name: 'vodEdit',
          webinarType: 'vod',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'vodEdit',
        component: () => import('@/views/LiveModule/edit'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016008')}`,
          name: 'vodCreate',
          webinarType: 'vod',
          activeMenu: '/live/vodEdit',
          auth_key: 'ui.upload_video_as_demand'
        }
      },
      {
        path: 'timeEdit',
        component: () => import('@/views/LiveModule/edit'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016009')}`,
          level: 2,
          name: 'liveTimeCreate',
          webinarType: 'time',
          activeMenu: '/live/timeEdit',
          auth_key: 'webinar.timing'
        }
      },
      {
        path: 'timeEdit/:id',
        component: () => import('@/views/LiveModule/edit'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016010')}`,
          level: 2,
          name: 'liveTimeEdit',
          webinarType: 'time',
          activeMenu: '/live/timeEdit'
        },
        hidden: true
      },
      {
        path: 'detail/:str(\\d+)',
        component: Detail,
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016011')}`,
          name: 'liveDetail',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'chooseWay/:str/:role?',
        component: () => import('@/views/LiveModule/chooseWay'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016012')}`,
          name: 'chooseWay',
          level: 3,
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'signup/:str(\\d+)',
        component: () => import('@/views/LiveModule/signUp/main'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016013')}`,
          name: 'signup',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'viewerRules/:str(\\d+)',
        component: () => import('@/views/LiveModule/viewerRules'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016014')}`,
          name: 'viewerRules',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'roleInvitation/:str(\\d+)',
        component: () => import('@/views/LiveModule/roleInvitation'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016015')}`,
          name: 'roleInvitation',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'planFunction/:str(\\d+)',
        component: () => import('@/views/LiveModule/planFunction'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016016')}`,
          name: 'planFunction',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'virtual/:str(\\d+)',
        component: () => import('@/views/LiveModule/virtual'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016017')}`,
          name: 'virtual',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'warm/:str(\\d+)',
        component: () => import('@/views/LiveModule/warm'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016018')}`,
          name: 'warm',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'embedCard/:str(\\d+)',
        component: () => import('@/views/LiveModule/embedCard'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016019')}`,
          name: 'embedCard',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'langCard/:str(\\d+)',
        component: () => import('@/views/LiveModule/langCard'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016020')}`,
          name: 'langCard',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'compliance/:str(\\d+)',
        component: () => import('@/views/LiveModule/Compliance'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016021')}`,
          name: 'compliance',
          activeMenu: '/live/list',
          appCls: 'std-app'
        },
        hidden: true
      },
      {
        path: 'pushStream/:str(\\d+)',
        component: () => import('@/views/LiveModule/pushStream'),
        meta: { auth: true, title: '推流地址', name: 'pushStream', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'msgNotification/:str(\\d+)',
        component: () => import('@/views/LiveModule/msgNotification'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016022')}`,
          name: 'msgNotification',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'pushCard/:str(\\d+)',
        component: () => import('@/views/LiveModule/PushCard/main'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016023')}`,
          name: 'pushCard',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'addPushCard',
        component: () => import('@/views/LiveModule/PushCard/components/addCard'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016024')}`,
          name: 'addPushCard',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'clickPushCard',
        component: () => import('@/views/LiveModule/PushCard/components/clickCard'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016025')}`,
          name: 'clickPushCard',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'livingSet/:str(\\d+)',
        component: () => import('@/views/LiveModule/Brands/livingSetting'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016026')}`,
          name: 'livingSetting',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'safeScreenSet/:str(\\d+)',
        component: () => import('@/views/LiveModule/Brands/safeScreenSet'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016027')}`,
          name: 'safeScreenSet',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'playerSet/:str(\\d+)',
        component: () => import('@/views/LiveModule/Brands/playerSet'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016028')}`,
          name: 'playerSet',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'invCard/:str(\\d+)',
        component: () => import('@/views/LiveModule/Invite/InvitationCard/invitationCard.vue'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016029')}`,
          name: 'invCard',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'advertCard/:str(\\d+)',
        component: () => import('@/views/LiveModule/Brands/advertisementCard'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016030')}`,
          name: 'advertCard',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'officialCard/:str(\\d+)',
        component: () => import('@/views/LiveModule/Brands/officialCard'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016031')}`,
          name: 'officialCard',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'officeSet/:str(\\d+)',
        component: () => import('@/views/LiveModule/Brands/officialCard'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016032')}`,
          name: 'officeSet',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'posterCard/:str(\\d+)',
        component: () => import('@/views/LiveModule/Brands/posterCard'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016033')}`,
          name: 'posterSet',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'shareSetting/:str(\\d+)',
        component: () => import('@/views/LiveModule/Invite/shareSetting'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016034')}`,
          name: 'shareSet',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'word/:str(\\d+)',
        component: () => import('@/views/MaterialModule/word'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016035')}`,
          name: 'word',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'videoSet/:str(\\d+)',
        component: () => import('@/views/LiveModule/MaterialSet/videoSet'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016036')}`,
          name: 'videoSet',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'signInSet/:str(\\d+)',
        component: () => import('@/views/LiveModule/MaterialSet/signInSet'),
        meta: { title: `${i18n.t('lang.k_016070')}`, name: 'signInSet' },
        hidden: true
      },
      {
        path: 'winnerList/:str(\\d+)',
        component: () => import('@/views/LiveModule/MaterialSet/winnerList'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016037')}`,
          name: 'winnerList',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'prizeList/:str(\\d+)',
        component: () => import('@/views/LiveModule/MaterialSet/prizeList'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016038')}`,
          name: 'prizeList',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'prizeSet/:str(\\d+)',
        component: () => import('@/views/LiveModule/MaterialSet/prizeSet'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016038')}`,
          name: 'prizeCreat',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'question/:str(\\d+)',
        component: () => import('@/views/LiveModule/MaterialSet/question'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016039')}`,
          name: 'question',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'addQuestion',
        component: () => import('@/views/LiveModule/MaterialSet/components/addQuestion'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016040')}`,
          name: 'addQuestion',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'exam/:str(\\d+)',
        component: () => import('@/views/LiveModule/Exam/main'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016041')}`,
          name: 'exam',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'addExam',
        component: () => import('@/views/LiveModule/Exam/components/addExam'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016024')}`,
          name: 'addExam',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'productSet/:str(\\d+)',
        component: () => import('@/views/MaterialModule/Products/index.vue'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016042')}`,
          name: 'productSet',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'couponData/:str(\\d+)',
        component: () => import('@/views/MaterialModule/Products/viewCoupon.vue'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016043')}`,
          name: 'couponData',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'gift/:str(\\d+)',
        component: () => import('@/views/LiveModule/MaterialSet/giftSet'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016044')}`,
          name: 'gift',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        // 列表
        path: 'InteractReward/:str(\\d+)',
        component: () => import('@/views/LiveModule/InteractReward/index.vue'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016045')}`,
          name: 'InteractReward',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        // 创建、编辑、复制共用
        path: 'InteractiveRewardSetting/:str(\\d+)',
        component: () => import('@/views/LiveModule/InteractReward/setting/index.vue'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016045')}`,
          name: 'InteractiveRewardSetting',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        // 领奖用户列表
        path: 'InteractiveRewardUserList/:str(\\d+)',
        component: () => import('@/views/LiveModule/InteractReward/UserList.vue'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016045')}`,
          name: 'InteractiveRewardUserList',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        // 列表
        path: 'WatchReward/:str(\\d+)',
        component: () => import('@/views/LiveModule/WatchReward/index.vue'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016046')}`,
          name: 'WatchReward',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        // 创建、编辑、复制共用
        path: 'WatchRewardSetting/:str(\\d+)',
        component: () => import('@/views/LiveModule/WatchReward/setting/index.vue'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016046')}`,
          name: 'WatchRewardSetting',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        // 领奖用户列表
        path: 'WatchRewardWinnerList/:str(\\d+)',
        component: () => import('@/views/LiveModule/WatchReward/WinnerList.vue'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016046')}`,
          name: 'WatchRewardWinnerList',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        // 列表
        path: 'CashPacket/:id',
        component: () => import('@/views/LiveModule/CashPacket/list.vue'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016047')}`,
          name: 'CashPacketList',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        // 创建/编辑
        path: 'CashPacket/edit/:id',
        component: () => import('@/views/LiveModule/CashPacket/edit.vue'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016047')}`,
          name: 'CashPacketEdit',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        //
        path: 'CashPacket/record/:id/:redpacket_id',
        component: () => import('@/views/LiveModule/CashPacket/receiptDetails.vue'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016048')}`,
          name: 'receiptDetails',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        // 列表
        path: 'MallRewards/:id',
        component: () => import('@/views/LiveModule/MallRewards/list.vue'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016049')}`,
          name: 'MallRewardsList',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        // 创建/编辑
        path: 'MallRewards/edit/:id',
        component: () => import('@/views/LiveModule/MallRewards/edit.vue'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016049')}`,
          name: 'MallRewardsEdit',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        //
        path: 'MallRewards/record/:id/:reward_id',
        component: () => import('@/views/LiveModule/MallRewards/receiptDetails.vue'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016048')}`,
          name: 'mallReceiptDetails',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'playback/:str(\\d+)',
        component: () => import('@/views/LiveModule/PlayBack/list'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016050')}`,
          name: 'playback',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'playback/:str(\\d+)/group/:switch_id(\\d+)',
        component: () => import('@/views/LiveModule/PlayBack/groupList'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016051')}`,
          name: 'playbackGroupList',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'recordplayback/:str(\\d+)',
        component: () => import('@/views/LiveModule/PlayBack/list'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016052')}`,
          name: 'recordplayback',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'publishplayback/:str(\\d+)',
        component: () => import('@/views/LiveModule/PlayBack/list'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016053')}`,
          name: 'publishplayback',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'vodreset/:str(\\d+)',
        component: () => import('@/views/LiveModule/PlayBack/vodreset'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016054')}`,
          name: 'vodreset',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'reportsData/:str(\\d+)',
        component: () => import('@/views/LiveModule/Data/reportsData'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016055')}`,
          name: 'reportsData',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'interactionData/:str(\\d+)',
        component: () => import('@/views/LiveModule/Data/interactData'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016056')}`,
          name: 'interactionData',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'userData/:str(\\d+)',
        component: () => import('@/views/LiveModule/Data/userData'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016057')}`,
          name: 'userData',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'interactionDetail',
        component: () => import('@/views/LiveModule/Data/interactDetail'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016058')}`,
          name: 'interactionDetail',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'interactionDetail/invitedDataInfo',
        component: () => import('@/views/LiveModule/Data/invitedDataInfo'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016059')}`,
          name: 'invitedDataInfo',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'lookSingleQuestion/:str(\\d+)',
        component: () => import('@/views/LiveModule/Data/lookSingleQuestion'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016060')}`,
          name: 'lookSingleQuestion',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'lookSingleExam/:str(\\d+)',
        component: () => import('@/views/LiveModule/Data/lookSingleExam'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016061')}`,
          name: 'lookSingleExam',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'channel/:str(\\d+)',
        component: () => import('@/views/LiveModule/Invite/channel'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016062')}`,
          name: 'channel',
          activeMenu: '/live/list',
          auth_key: 'watch.channel'
        },
        hidden: true
      },
      {
        path: 'AI/chat/list/:id(\\d+)',
        component: () => import('@/views/AIModule/chat/list'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016063')}`,
          name: 'AIChatListLive',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'AI/chat/create',
        component: () => import('@/views/AIModule/chat/edit'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016024')}`,
          name: 'AIChatCreateLive',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'AI/chat/edit/:id(\\d+)',
        component: () => import('@/views/AIModule/chat/edit'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016064')}`,
          name: 'AIChatEditLive',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'embedPage/:str(\\d+)/:type/:index',
        component: () => import('@/views/LiveModule/embedPage'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016065')}`,
          name: 'embedPage',
          activeMenu: '/live/list'
        },
        hidden: true
      }
    ]
  },
  // 专题路由
  {
    path: '/special',
    component: Layout,
    redirect: '/special/list',
    meta: {
      auth: true,
      title: `${i18n.t('lang.k_016066')}`,
      name: 'specialList',
      icon: 'saasicon_projects_img',
      level: 1,
      auth_key: 'subject_manager'
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/SpecialModule/list'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016066')}`,
          name: 'specialList',
          level: 2,
          activeMenu: '/special/list',
          auth_key: 'subject_manager'
        }
      },
      {
        path: 'edit',
        component: () => import('@/views/SpecialModule/edit'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016067')}`,
          name: 'subjectEdit',
          level: 2,
          activeMenu: '/special/edit',
          auth_key: 'subject_manager'
        },
        hidden: true
      },
      {
        path: 'edit/:id',
        component: () => import('@/views/SpecialModule/edit'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016068')}`,
          name: 'subjectEdit',
          level: 2,
          activeMenu: '/special/list',
          auth_key: 'subject_manager'
        },
        hidden: true
      },
      {
        path: 'data/:id',
        component: () => import('@/views/SpecialModule/data'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016058')}`,
          // 导出数据
          name: 'subjectData',
          level: 2,
          activeMenu: '/special/list',
          auth_key: 'subject_manager'
        },
        hidden: true
      },
      {
        path: 'viewer/:id',
        component: () => import('@/views/SpecialModule/viewer'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016014')}`,
          name: 'subjectViewer',
          level: 2,
          activeMenu: '/special/list',
          auth_key: 'subject_manager'
        },
        hidden: true
      },
      {
        path: 'details/:id',
        component: () => import('@/views/SpecialModule/details'),
        meta: {
          auth: true,
          title: `${i18n.t('lang.k_016069')}`,
          name: 'subjectDetails',
          level: 2,
          activeMenu: '/special/list',
          auth_key: 'subject_manager'
        },
        hidden: true
      }
    ]
  },
  {
    path: '/chooseWay/:str/:role?',
    component: () => import('@/views/LiveModule/chooseWay'),
    meta: {
      auth: true,
      title: `${i18n.t('lang.k_016012')}`,
      name: 'chooseWay'
    },
    hidden: true
  }
];
export default router;
